import httpService from './httpService';

export function acceptCrmUserInvite(token: string, body: object): Promise<void> {
  return httpService
    .post(`/networks/businesses/0/integrations/invite/accept?token=${encodeURIComponent(token)}`, body)
    .then(() => {});
}
